module.exports = __webpack_public_path__ + "img/ireland.486d1ba3.png";